import {
    CREATE_BILL_RECEIVING_FAILURE,
    CREATE_BILL_RECEIVING_REQUEST,
    CREATE_BILL_RECEIVING_SUCCESS,
    CREATE_USERFORM_BILL_RECEIVING,
    DELETE_BILL_RECEIVING_FAILURE,
    DELETE_BILL_RECEIVING_REQUEST,
    DELETE_BILL_RECEIVING_SUCCESS,
    FETCH_ALL_BILL_RECEIVING_FAILURE,
    FETCH_ALL_BILL_RECEIVING_REQUEST,
    FETCH_ALL_BILL_RECEIVING_SUCCESS,
    FETCH_BY_ID_BILL_RECEIVING_FAILURE,
    FETCH_BY_ID_BILL_RECEIVING_REQUEST,
    FETCH_BY_ID_BILL_RECEIVING_SUCCESS,
    RESET_BILL_RECEIVING_USERFORM,
    UPDATE_BILL_RECEIVING_FAILURE,
    UPDATE_BILL_RECEIVING_REQUEST,
    UPDATE_BILL_RECEIVING_SUCCESS

} from "./billsReceived.actionType";

export const BILL_RECEIVING = 'billReceiving';

let initialState = {
    loading: false,
    billReceivingData: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
    },
    errorMessage: '',
}

export let billReceivingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_BILL_RECEIVING_REQUEST:
        case FETCH_BY_ID_BILL_RECEIVING_REQUEST:
        case CREATE_BILL_RECEIVING_REQUEST:
        case UPDATE_BILL_RECEIVING_REQUEST:
        case DELETE_BILL_RECEIVING_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ALL_BILL_RECEIVING_SUCCESS:
            return {
                ...state,
                loading: false,
                billReceivingData: updatePayload
            }
        case FETCH_BY_ID_BILL_RECEIVING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                }
            }
        case CREATE_USERFORM_BILL_RECEIVING:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_BILL_RECEIVING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                }
            }
        case UPDATE_BILL_RECEIVING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                }
            }
        case DELETE_BILL_RECEIVING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                }
            }
        case FETCH_ALL_BILL_RECEIVING_FAILURE:
        case FETCH_BY_ID_BILL_RECEIVING_FAILURE:
        case CREATE_BILL_RECEIVING_FAILURE:
        case UPDATE_BILL_RECEIVING_FAILURE:
        case DELETE_BILL_RECEIVING_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case RESET_BILL_RECEIVING_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                },
            };

        default:
            return state;
    }
}